export class BackupPolicyConfig {
    'id';
    'name';
    'enabled';
    'userCreated';
    'dateCreated';
    'dateModified';
    'attachedResources';
    'processing';
    'condition';
    'include';
    'exclude';
    'schedules';
    'isSecurityScanEnabled';
    'sourceCloudProvider';
    'policyType';
    'scheduleMode';
    'resourceTypes';
    'awsNativePitrConfig';
    'bigQueryNativePitrConfig';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "enabled",
            "baseName": "enabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "userCreated",
            "baseName": "userCreated",
            "type": "string",
            "format": ""
        },
        {
            "name": "dateCreated",
            "baseName": "dateCreated",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "dateModified",
            "baseName": "dateModified",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "attachedResources",
            "baseName": "attachedResources",
            "type": "number",
            "format": ""
        },
        {
            "name": "processing",
            "baseName": "processing",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "condition",
            "baseName": "condition",
            "type": "Condition",
            "format": ""
        },
        {
            "name": "include",
            "baseName": "include",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "exclude",
            "baseName": "exclude",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "schedules",
            "baseName": "schedules",
            "type": "Array<BackupSchedule>",
            "format": ""
        },
        {
            "name": "isSecurityScanEnabled",
            "baseName": "isSecurityScanEnabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "sourceCloudProvider",
            "baseName": "sourceCloudProvider",
            "type": "Provider",
            "format": ""
        },
        {
            "name": "policyType",
            "baseName": "policyType",
            "type": "BackupPolicyType",
            "format": ""
        },
        {
            "name": "scheduleMode",
            "baseName": "scheduleMode",
            "type": "ScheduleMode",
            "format": ""
        },
        {
            "name": "resourceTypes",
            "baseName": "resourceTypes",
            "type": "Array<ResourceType>",
            "format": ""
        },
        {
            "name": "awsNativePitrConfig",
            "baseName": "awsNativePitrConfig",
            "type": "AwsNativePitrConfig",
            "format": ""
        },
        {
            "name": "bigQueryNativePitrConfig",
            "baseName": "bigQueryNativePitrConfig",
            "type": "BigQueryNativePitrConfig",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return BackupPolicyConfig.attributeTypeMap;
    }
    constructor() {
    }
}
